// extracted by mini-css-extract-plugin
module.exports = {"sectionGrid":"ReferralStats_sectionGrid__Pq_4x","hiddenIcon":"ReferralStats_hiddenIcon__HL5X7","spacing":"ReferralStats_spacing__BwCi8"};